import { useQuery, useMutation, useQueryClient } from "react-query";
import { getLookups, getToleranceById, getTolerances, saveTolerances } from "@/api/Maintainers/OA/oa-tolerances-api";

export const key = "oa-tolerances";

export function useToleranceLookups(filters) {
	return useQuery([key, "lookups", filters], () => getLookups());
}

export function useTolerances(filters) {
	return useQuery([key, "list", filters], () => getTolerances(filters), {
		keepPreviousData: true,
	});
}

export function useToleranceById(id_element, enabled = true) {
	return useQuery([key, "detail", id_element], () => getToleranceById(id_element), {
		enabled: !!enabled && !!id_element,
		keepPreviousData: true,
	});
}

export function useSaveTolerances() {
	const queryClient = useQueryClient();

	return useMutation(saveTolerances, {
		onSuccess: () => {
			queryClient.invalidateQueries([key, "list"]);
		},
	});
}
